module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qpelv5-902227386b5375817d30b50d83f26352.jpg";